export default __webpack_public_path__ + "static/media/wave6.b1ad6e22.png";